import { render, staticRenderFns } from "./ModuleUploadedFiles.vue?vue&type=template&id=3b0ebfe5"
import script from "./ModuleUploadedFiles.vue?vue&type=script&lang=js"
export * from "./ModuleUploadedFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports